import { CellSimple } from "@maxhub/max-ui"
import { PlaceholderIcon } from "../shared/PlaceholderIcon"

export const CellSimpleAsLinkExample = {
  title: "CellSimple - As link",
  defaultPlatform: "ios",
  defaultZoom: 100,

  controls: [],

  Preview() {
    return (
      <CellSimple
        asChild
        before={<PlaceholderIcon />}
        height="normal"
        title="Я — ссылка!"
      >
        <a
          href="/"
          rel="noreferrer"
          target="_blank"
        />
      </CellSimple>
    )
  },

  getCode() {
    return `<CellSimple
  asChild
  before={<Icon24Placeholder />}
  height="normal"
  title="Я — ссылка!"
>
  <a
    href="/"
    rel="noreferrer"
    target="_blank"
  />
</CellSimple>`
  },
}